var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-container" },
    [
      _c(
        "el-tabs",
        { staticClass: "setting-tabs", attrs: { "tab-position": "left" } },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "提交设置" } },
            [_c("submit-setting")],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "回收设置" } },
            [_c("write-setting")],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "通知设置" } },
            [_c("notify-setting")],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "分享设置" } },
            [_c("share-setting")],
            1
          ),
          _c("el-tab-pane", { attrs: { label: "页面设置" } }, [
            _c(
              "div",
              { staticClass: "project-setting-view" },
              [
                _c("p", { staticClass: "project-setting-title" }, [
                  _vm._v(" 页面设置 "),
                  _c(
                    "span",
                    {
                      staticClass: "small-font-size ml20 text-secondary-color",
                    },
                    [_vm._v(" 问卷填写时题目的交互方式 ")]
                  ),
                ]),
                _c("el-divider"),
                _c(
                  "el-form",
                  {
                    ref: "pageSettingForm",
                    attrs: { model: _vm.pageSettingForm },
                    nativeOn: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "setting-item" },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "label",
                            staticStyle: { width: "30%" },
                          },
                          [_vm._v("页面交互方式")]
                        ),
                        _c(
                          "el-radio-group",
                          {
                            directives: [
                              {
                                name: "removeAriaHidden",
                                rawName: "v-removeAriaHidden",
                              },
                            ],
                            model: {
                              value: _vm.pageSettingForm.pageShowType,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.pageSettingForm,
                                  "pageShowType",
                                  $$v
                                )
                              },
                              expression: "pageSettingForm.pageShowType",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "more" } }, [
                              _vm._v(" 一页多题 "),
                            ]),
                            _c("el-radio", { attrs: { label: "single" } }, [
                              _vm._v(" 一页一题 "),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "submit-btn" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.saveSettingHandle },
                          },
                          [_vm._v(" 保存设置 ")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }